import { Component, EventEmitter, OnInit, Output, Input } from '@angular/core';
import { ClaimParserService } from '../../services/claim-parser.service';
import { Client } from '../../models/client';
import { RouteParamsService } from '../../services/route-params.service';
import { Router } from '@angular/router';
import { Select, Selector, Store } from '@ngxs/store';
import {
  ClientSelected,
  ClientSelectionState,
  SetAvailableClients
} from '../../state/ClientSelectionState/ClientSelection.state';
import { Observable } from 'rxjs';
import { Navigate } from '@ngxs/router-plugin';
import { UserManagementService } from '../../services/user-management.service';

@Component({
  selector: 'lib-client-switcher',
  templateUrl: './client-switcher.component.html',
  styleUrls: ['./client-switcher.component.css'],
  standalone: false
})
export class ClientSwitcherComponent implements OnInit {
  @Input() public prompt: string = 'Select Client';
  @Select(ClientSelectionState.shouldShowClientSwitcher)
  public showSwitcher: Observable<boolean>;
  @Select(ClientSelectionState.availableClients)
  public companyData: Observable<Client[]>;
  @Select(ClientSelectionState.clientCode)
  public chosenCompany: Observable<string>;
  constructor(
    private userManagementService: UserManagementService,
    private store: Store
  ) {}

  ngOnInit(): void {
    const availableCompanies = this.store.selectSnapshot(ClientSelectionState.availableClients);
    if (availableCompanies == null) {
      //This should only happen if ClientGuard never executed, which means
      //The user navigated manually to a route that already contained a client code.
      this.userManagementService.getUserClients().subscribe(clients => {
        this.store.dispatch(new SetAvailableClients(clients));
      });
    }
  }

  public switchCompany(code: string) {
    this.store.dispatch(new ClientSelected(code)).subscribe(_ => {
      this.store.dispatch(new Navigate([`/${code}`]));
    });
  }
}
